import { useMediaQuery, SxProps } from "@mui/material";
import UIHilight from '../components/ui-hilight';

type HeaderProps = {
    size: "sm" | "md" | "lg";
    text: string;
    sx?: SxProps; // Add the sx prop
};

export default function Header({ size, text, sx }: HeaderProps) {
    const isDesktop = useMediaQuery("(min-width:600px)");

    let fontSize;
    let fontWeight;
    switch (size) {
        case "lg":
            fontSize = isDesktop ? "4rem" : "1.8rem";
            fontWeight = 600;
            break;
        case "md":
            fontSize = isDesktop ? "3rem" : "2rem";
            fontWeight = 600;
            break;
        case "sm":
            fontSize = isDesktop ? "2rem" : "1.5rem";
            fontWeight = 500;
            break;
        default:
            fontSize = isDesktop ? "2rem" : "1.5rem";
            fontWeight = 500;
            break;
    }

    return (
        <UIHilight text={text} fontWeight={fontWeight} fontSize={fontSize} sx={sx} />
    );

}
